// src/components/Sidebar.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import logo from '../assets/logo.png';

export default function Sidebar({ onLogout }) {
  const loc = useLocation();
  return (
      
      <nav className="w3-black sidebar w3-bar-block w3-center">

       <div className="w3-bar-item brand w3-small">
      <img src={logo} className="sidebar-logo" alt="logo" />
        EINCUBATOR<br />
        version:1.0
      </div>

        <Link className={loc.pathname === "/dashboard" ? "active w3-bar-item " : "w3-bar-item "} to="/dashboard">Dashboard</Link>

        <Link className={loc.pathname.startsWith("/projects") ? "active w3-bar-item " : "w3-bar-item "} to="/projects">My Projects</Link>

        <Link className={loc.pathname === "/contributions" ? "active w3-bar-item " : " w3-bar-item "} to="/contributions">Investors</Link>

 <div className=" w3-bar-item ">
        <button className="btn-muted" onClick={onLogout}>Logout</button>
      </div>
      </nav>

       );
}